import { ApplianceId, Scenario, ScenarioId } from '../../engine/types';

import { byHourSegments } from './curves';

export const summertimeStorms: Scenario = {
  description: 'A heat wave, an afternoon storm, and a family that really, really wants the AC on.',
  events: [
    {
      atMinute: 0,
      from: 'Sam',
      id: 'storm-morning',
      responses: [{ effect: { moodDelta: 2 }, label: 'Stay cool out there' }],
      text: 'Phew — already sticky out there. Off to work. Kids are home all summer, so the AC is yours to referee.',
    },
    {
      atMinute: 60,
      from: 'Sam',
      id: 'storm-warning',
      responses: [
        { effect: { moodDelta: 2 }, label: 'On it. Charging everything.' },
        { effect: { moodDelta: 0, reaction: 'Sam: famous last words' }, label: 'It’s probably nothing' },
      ],
      text: 'Storm warnings all afternoon. News says line damage is likely — charge your stuff now.',
    },
    {
      atMinute: 120,
      from: 'Grid Alert',
      id: 'storm-outage',
      responses: [],
      text: 'A storm cell just took down the grid. Estimated restoration: noon tomorrow. It’s 92°F outside.',
    },
    {
      atMinute: 135,
      from: 'Riley',
      id: 'storm-ac-choice',
      requiresLoadOff: ApplianceId.HVAC,
      responses: [
        {
          effect: { durationMinutes: 240, moodDelta: 3, startLoads: [ApplianceId.HVAC] },
          grantsAsk: true,
          label: 'AC through the afternoon',
        },
        {
          effect: { moodDelta: -2, reaction: 'Riley: this is a violation of my rights' },
          label: 'Fans and popsicles for now',
        },
      ],
      text: 'the AC just STOPPED?? turn it back on it’s so hot',
    },
    {
      atMinute: 135,
      from: 'Riley',
      id: 'storm-ac-choice-on',
      requiresLoadOn: ApplianceId.HVAC,
      responses: [
        {
          effect: { durationMinutes: 240, moodDelta: 3, startLoads: [ApplianceId.HVAC] },
          grantsAsk: true,
          label: 'Keep the AC running',
        },
        {
          effect: {
            moodDelta: -2,
            reaction: 'Riley: this is a violation of my rights',
            stopLoads: [ApplianceId.HVAC],
          },
          label: 'Fans and popsicles — save the battery',
        },
      ],
      text: 'power’s out but the AC is still running?? do NOT touch it',
    },
    {
      atMinute: 210,
      from: 'Jojo',
      id: 'storm-melting',
      requiresIndoorAbove: 76,
      responses: [
        {
          effect: { durationMinutes: 60, moodDelta: 4, startLoads: [ApplianceId.HVAC] },
          grantsAsk: true,
          label: 'OK — one hour of AC',
        },
        { effect: { moodDelta: 2, reaction: 'Jojo: CANNONBALL' }, label: 'Sprinkler time in the backyard!' },
      ],
      text: 'im MELTING can we do AC just a little 🫠',
    },
    {
      atMinute: 330,
      from: 'Home',
      id: 'storm-kids-inside',
      requiresSolar: true,
      responses: [],
      text: 'The storm rolls in. Everyone’s inside, the sky has gone green-gray, and the panels are barely sipping light.',
    },
    {
      atMinute: 330,
      from: 'Home',
      id: 'storm-kids-inside-nosolar',
      requiresSolar: false,
      responses: [],
      text: 'The storm rolls in. Everyone’s inside and the sky has gone green-gray.',
    },
    {
      atMinute: 360,
      from: 'Sam',
      id: 'storm-fridge-door',
      responses: [
        { effect: { moodDelta: 1 }, label: 'Closed-door policy, effective now' },
        { effect: { moodDelta: 2, reaction: 'The fridge weeps quietly.' }, label: 'Let them have this' },
      ],
      text: 'The kids keep standing in front of the open fridge “to cool off”',
    },
    {
      atMinute: 450,
      from: 'Sam',
      id: 'storm-dinner',
      responses: [
        {
          effect: { moodDelta: 4, reaction: 'Sam: rain stopped just in time. grill hero' },
          grantsAsk: true,
          label: 'Grill out back',
        },
        {
          effect: { durationMinutes: 20, moodDelta: 2, startLoads: [ApplianceId.OVEN] },
          label: 'Quick stovetop stir-fry',
        },
      ],
      text: 'Home — roads were a mess. No oven tonight, right? Grill or something quick?',
    },
    {
      atMinute: 540,
      from: 'Grid Alert',
      id: 'storm-second-cell',
      responses: [],
      text: 'A second storm cell rolls through. No solar until it clears.',
    },
    {
      atMinute: 630,
      from: 'Riley',
      id: 'storm-ev',
      requiresLoadOff: ApplianceId.EV_CHARGER,
      responses: [
        {
          effect: { durationMinutes: 180, moodDelta: 1, startLoads: [ApplianceId.EV_CHARGER] },
          grantsAsk: true,
          label: 'Charge it tonight',
        },
        { effect: { moodDelta: 0, reaction: 'Riley: 🤞🤞🤞' }, label: 'We’ll risk a morning sip' },
      ],
      text: 'can you charge the car? i have practice at 7am',
    },
    {
      atMinute: 720,
      from: 'Home',
      id: 'storm-lights-out',
      responses: [],
      text: 'Lights out. The house is warm and the night is warmer.',
    },
    {
      atMinute: 900,
      from: 'Sam',
      id: 'storm-night-sticky',
      requiresIndoorAbove: 76,
      responses: [
        {
          effect: { durationMinutes: 60, moodDelta: 4, startLoads: [ApplianceId.HVAC] },
          grantsAsk: true,
          label: 'One hour, then windows',
        },
        {
          effect: { moodDelta: -2, reaction: 'Sam: the crickets better be worth it' },
          label: 'Windows open, everything off',
        },
      ],
      text: 'It is SO stuffy up here. Nobody is sleeping. AC for a bit?',
    },
    {
      atMinute: 1260,
      from: 'Jojo',
      id: 'storm-breakfast',
      responses: [
        {
          effect: { durationMinutes: 30, moodDelta: 3, startLoads: [ApplianceId.OVEN] },
          grantsAsk: true,
          label: 'Hot breakfast — we earned it',
        },
        { effect: { moodDelta: 0, reaction: 'Jojo: cold cereal for warm people' }, label: 'Cereal and fruit' },
      ],
      text: 'we survived!! pancakes to celebrate?',
    },
    {
      atMinute: 1440,
      from: 'Home',
      id: 'storm-clear',
      requiresSolar: true,
      responses: [],
      text: 'The sky breaks open, blue and rinsed clean. The panels are drinking it in.',
    },
    {
      atMinute: 1440,
      from: 'Home',
      id: 'storm-clear-nosolar',
      requiresSolar: false,
      responses: [],
      text: 'The sky breaks open, blue and rinsed clean.',
    },
  ],
  id: ScenarioId.SUMMERTIME_STORMS,
  kidsHomeFromMinute: 0,
  name: 'Summertime Storms',
  outdoorTempByHour: byHourSegments([
    [6, 76],
    [9, 80],
    [12, 88],
    [15, 93],
    [18, 94],
    [21, 86],
    [24, 80],
  ]),
  solarFactorByHour: byHourSegments([
    [13, 1],
    [20, 0.2],
    [24, 0],
  ]),
  solarFactorByHourDayTwo: byHourSegments([[24, 0.9]]),
};
